import { Fade } from '@chakra-ui/react'

export default Fade
